import React, { useEffect, useState } from 'react';
import { CheckCircle, AlertCircle, X } from 'lucide-react';
export type ToastType = 'success' | 'error' | 'info';
interface ToastProps {
  message: string;
  type?: ToastType;
  duration?: number;
  onClose: () => void;
}
export function Toast({
  message,
  type = 'success',
  duration = 3000,
  onClose
}: ToastProps) {
  const [isVisible, setIsVisible] = useState(true);
  useEffect(() => {
    const timer = setTimeout(() => {
      setIsVisible(false);
      setTimeout(onClose, 300); // Allow time for exit animation
    }, duration);
    return () => clearTimeout(timer);
  }, [duration, onClose]);
  const getIcon = () => {
    switch (type) {
      case 'success':
        return <CheckCircle className="w-5 h-5 text-green-400" data-id="element-1185" />;
      case 'error':
        return <AlertCircle className="w-5 h-5 text-red-400" data-id="element-1186" />;
      case 'info':
        return <AlertCircle className="w-5 h-5 text-blue-400" data-id="element-1187" />;
    }
  };
  const getBgColor = () => {
    switch (type) {
      case 'success':
        return 'bg-green-500/20 border-green-500/30';
      case 'error':
        return 'bg-red-500/20 border-red-500/30';
      case 'info':
        return 'bg-blue-500/20 border-blue-500/30';
    }
  };
  return <div className={`fixed bottom-4 right-4 z-50 transition-all duration-300 ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-2'}`} data-id="element-1188">
      <div className={`p-4 rounded-lg shadow-lg border ${getBgColor()} flex items-center gap-3 max-w-md`} data-id="element-1189">
        {getIcon()}
        <p className="text-white flex-1" data-id="element-1190">{message}</p>
        <button onClick={onClose} className="text-gray-400 hover:text-white" data-id="element-1191">
          <X className="w-4 h-4" data-id="element-1192" />
        </button>
      </div>
    </div>;
}
export function useToast() {
  const [toasts, setToasts] = useState<Array<{
    id: string;
    message: string;
    type: ToastType;
  }>>([]);
  const showToast = (message: string, type: ToastType = 'success') => {
    const id = Math.random().toString(36).substring(2, 9);
    setToasts(prev => [...prev, {
      id,
      message,
      type
    }]);
  };
  const closeToast = (id: string) => {
    setToasts(prev => prev.filter(toast => toast.id !== id));
  };
  const ToastContainer = () => <>
      {toasts.map(toast => <Toast key={toast.id} message={toast.message} type={toast.type} onClose={() => closeToast(toast.id)} data-id="element-1193" />)}
    </>;
  return {
    showToast,
    ToastContainer
  };
}